import { View, StyleSheet } from "react-native";
import { useState } from "react";
import Pagination from "../../../components/common/TableControls/Pagination/Pagination";
import ItemsPerPageDropdown from "../../../components/common/TableControls/ItemsPerPageDropdown/ItemsPerPageDropdown";
import CustomText from "../../../components/common/general/CustomText/CustomText";

const TableControlsContainer = ({
  page,
  setPage,
  pageSize,
  setPageSize,
  totalCount,
}: {
  page: number;
  setPage: (page: number) => void;
  pageSize: number;
  setPageSize: (pageSize: number) => void;
  totalCount: number;
}) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const totalPageCount = Math.ceil(totalCount / pageSize);

  const handlePageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize);
    setPage(1);
    setShowDropdown(false);
  };

  const handlePageChangeWrapper = (newPage: number) => {
    setPage(newPage);
  };

  const pageSizeOptions = [5, 10, 20, 50, 100];

  const startIndex = (page - 1) * pageSize + 1;
  const endIndex = Math.min(page * pageSize, totalCount);

  return (
    <View style={styles.container}>
      <Pagination page={page} handlePageChange={handlePageChangeWrapper} totalPageCount={totalPageCount} />
      <CustomText
        size="s"
        text="range_text"
        interpolation={{ startIndex, endIndex, totalCount }}
        style={{ color: "#6B7280", marginTop: 16 }}
      />
      <ItemsPerPageDropdown
        pageSize={pageSize}
        setShowDropdown={setShowDropdown}
        showDropdown={showDropdown}
        handlePageSizeChange={handlePageSizeChange}
        pageSizeOptions={pageSizeOptions}
      />
    </View>
  );
};

export default TableControlsContainer;

const styles = StyleSheet.create({
  container: {
    position: "relative",
    flexDirection: "row",
    alignItems: "center",
    gap: 16,
    justifyContent: "space-between",
    width: "100%",
    zIndex: 1000,
    elevation: 10,
    overflow: "visible",
  },
});
